var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.15 0.84998L18.33 1.66998L17.38 0.70998C16.99 0.31998 16.36 0.31998 15.96 0.70998L15 1.66998L14.04 0.70998C13.65 0.31998 13.01 0.31998 12.62 0.70998L11.67 1.66998L10.71 0.70998C10.32 0.31998 9.69 0.31998 9.3 0.70998L8.34 1.66998L7.38 0.70998C6.99 0.31998 6.36 0.31998 5.96 0.70998L5 1.66998L4.04 0.70998C3.65 0.31998 3.01 0.31998 2.62 0.70998L1.67 1.66998L0.85 0.84998C0.54 0.53998 0 0.75998 0 1.20998V16C0 17.1 0.9 18 2 18H18C19.1 18 20 17.1 20 16V1.20998C20 0.75998 19.46 0.53998 19.15 0.84998ZM9 16H2V9.99998H9V16ZM18 16H11V14H18V16ZM18 12H11V9.99998H18V12ZM18 7.99998H2V4.99998H18V7.99998Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsMenuIcon);
export default __webpack_public_path__ + "static/media/NewsMenuIcon.b5a00cf3f1a9761ff92e19ce7b9bedd5.svg";
export { ForwardRef as ReactComponent };